(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["odity-contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.OdityContactForm form').forEach((form) => {
      const i18n = {
        firstNameRequired: form.dataset.i18nFirstNameRequired,
        firstNameMin: form.dataset.i18nFirstNameMin,
        lastNameRequired: form.dataset.i18nLastNameRequired,
        lastNameMin: form.dataset.i18nLastNameMin,
        emailRequired: form.dataset.i18nEmailRequired,
        emailInvalid: form.dataset.i18nEmailInvalid,
        phoneInvalid: form.dataset.i18nPhoneInvalid,
        subjectRequired: form.dataset.i18nSubjectRequired,
        subjectMin: form.dataset.i18nSubjectMin,
        descriptionRequired: form.dataset.i18nDescriptionRequired,
        descriptionMin: form.dataset.i18nDescriptionMin,
      };
      const validator = new window.JustValidate(form, {
        errorFieldCssClass: 'is-invalid',
        errorLabelCssClass: 'form-error',
        successFieldCssClass: 'is-valid',
        validateBeforeSubmitting: true,
      });

      validator
        .addField('input[name="00N2p000006x2AT"]', [
          {
            rule: 'required',
            errorMessage: i18n.firstNameRequired,
          },
          {
            rule: 'minLength',
            value: 2,
            errorMessage: i18n.firstNameMin,
          },
        ])
        .addField('input[name="00N2p000006x29u"]', [
          {
            rule: 'required',
            errorMessage: i18n.lastNameRequired,
          },
          {
            rule: 'minLength',
            value: 2,
            errorMessage: i18n.lastNameMin,
          },
        ])
        .addField('input[name="00N2p000006x29z"]', [
          {
            rule: 'required',
            errorMessage: i18n.emailRequired,
          },
          {
            rule: 'email',
            errorMessage: i18n.emailInvalid,
          },
        ])
        .addField('input[name="phone"]', [
          {
            rule: 'minLength',
            value: 10,
            errorMessage: i18n.phoneInvalid,
          },
        ])
        // Subject
        .addField('input[name="subject"]', [
          {
            rule: 'required',
            errorMessage: i18n.subjectRequired,
          },
          {
            rule: 'minLength',
            value: 3,
            errorMessage: i18n.subjectMin,
          },
        ])
        // Description
        .addField('textarea[name="description"]', [
          {
            rule: 'required',
            errorMessage: i18n.descriptionRequired,
          },
          {
            rule: 'minLength',
            value: 10,
            errorMessage: i18n.descriptionMin,
          },
        ])
        .onSuccess((e) => {
          form.submit();
        })
        .onFail(() => {
          const firstError = form.querySelector('.is-invalid');
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstError.focus();
          }
        });

      // Prevent default submission to validate first
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        validator.revalidate();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
